// Deterministic color generator from a string (name -> hex color)
export function getColorForName(name){
  if(!name) return '#1f2937';
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  const color = ((hash >>> 0) % 0xFFFFFF).toString(16).padStart(6, '0');
  return `#${color}`;
}